module.exports = __webpack_public_path__ + "img/cash_flow.6182eec0.jpg";